// For V3 gates: https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage
import { gate as v3Gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';

/**
 * Returns true if the current portal has the provided gate
 */
export function useHasGate(gate) {
  const {
    gates
  } = userInfoSync();
  return gates.includes(gate);
}
export function useHasNonBillableM1Gate() {
  return useHasGate(v3Gate('Subscriptions:NonBillableM1'));
}
export function useHasContractM2Gates() {
  const hasPrivateBetaGate = useHasGate(v3Gate('Commerce:Contracts:PrivateBeta'));
  const hasM2Gate = useHasGate(v3Gate('Commerce:Contracts:M2:ChangesWithoutProration'));
  return hasPrivateBetaGate && hasM2Gate;
}